import { SetStateAction, useEffect, useRef, useState } from 'react';
import { Alert, AlertColor, Box, Button, Card, CardContent, CircularProgress, FormControl, FormControlLabel, Grid, Icon, IconButton, InputAdornment, InputBase, InputLabel, ListItem, ListItemText, MenuItem, OutlinedInput, Paper, Radio, RadioGroup, Select, Stack, Table, TextField, ToggleButton, Typography } from '@mui/material';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useVForm } from 'shared/forms';
import { FerramentasDeDetalhe, InputError, ConfirmacaoModal } from 'shared/components';
import { LayoutBaseDePagina } from 'shared/layouts';
import { ICreateComunicacao, IHelpTags, IListagemComunicacao, IListagemFornecedora, IResponseComunicacao, InicitalCreateComunicacao } from 'shared/types';
import { t } from 'i18next';
import { useHasPermissionAcao } from 'shared/hooks';
import { IKeyValue, listagemCanalToIKeyValue, listagemOrgToIKeyValue } from 'shared/utils';
import { CanaisService } from 'shared/services/canais/canaisService';
import { FornecedorasService } from 'shared/services/fornecedoras/fornecedorasService';
import { OrganizationsService } from 'shared/services/organizations/organizationsService';
import EmojiPicker, { EmojiClickData } from 'emoji-picker-react';
import { useSelectedOrganization } from 'shared/store/organization';
import { ComunicacaoService } from 'shared/services/comunicacao/comunicacaoService';
import Modal from '@mui/material/Modal';
import CloseIcon from '@material-ui/icons/Close';
import { TableCell, TableRow, TableContainer, TableHead, Autocomplete } from '@mui/material';




const validationSchema = yup.object({
  IdCanal: yup.string().required(),
  IdFornecedora: yup.string().required(),
  Comunicacao: yup.string(),
  TextoCliente: yup.string(),
  ComunicacaoDescricao: yup.string(),
  IdCampanhaExt: yup.string(),
  IdCampanhaCampo: yup.string(),
  ComunicacaoTipo: yup.string(),
  ComunicacaoTitulo: yup.string(),
  urlImagem: yup.string(),
  acaoAndrd: yup.string(),
  acaoIos: yup.string(),
  cdComunicacaoExt: yup.string(),
  dhIniExt: yup.date(),
  dhFinExt: yup.date(),
  campanhaExtStatu: yup.string(),
  idComunicacaoExt: yup.string(),
  qtdDisparo: yup.string(),
  cdMalaDireta: yup.string(),
  indGrpContrExt: yup.string(),
  cdComGcExt: yup.string(),
  idCampanha: yup.number(),
  AssuntoEmail: yup.string(),
  RemetenteEmail: yup.string(),
  NomeRemetenteEmail: yup.string(),
  RespostaEmail: yup.string(),
  nomePasta: yup.string(),
  nomeArquivo: yup.string(),


});

export const DetalheDeComunicacao: React.FC = () => {

  const { id = 'novo' } = useParams<'id'>();
  const { Fornecedora } = useParams<'Fornecedora'>();
  const navigate = useNavigate();
  const org = useSelectedOrganization();
  const [searchParams, setSearchParams] = useSearchParams();

  const hasPermitionCreate = useHasPermissionAcao('comunicacao', 'CRE');
  const hasPermitionUpdate = useHasPermissionAcao('comunicacao', 'UPD');
  const hasPermitionRead = useHasPermissionAcao('comunicacao', 'REA');

  const [alert, setAlert] = useState<null | { text: string; type: AlertColor }>(null);
  const { formRef, save, isSaveAndClose } = useVForm();

  const { register, handleSubmit, reset, watch, formState: { errors }, } = useForm({
    resolver: yupResolver(validationSchema),
    reValidateMode: 'onBlur'
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [titleConfirmacao, setTitleConfirmacao] = useState('');
  const [openConfirmacao, setOpenConfirmacao] = useState(false);
  const [messageConfirmacao, setMessageConfirmacao] = useState('');
  const [comunicacao, setComunicacao] = useState<IListagemComunicacao>();
  const [listKeyValueCanal, setListKeyValueCanal] = useState<IKeyValue[]>([]);
  const [listKeyValueOrg, setListKeyValueOrg] = useState<IKeyValue[]>([]);
  const [listKeyValueFornecedora, setListKeyValueFornecedora] = useState<IListagemFornecedora[]>([]);
  const [isLoadingCanal, setIsLoadingCanal] = useState(true);
  const [isLoadingFornecedora, setisLoadingFornecedora] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [rows, setRows] = useState<IHelpTags[]>([]);
  const [selectedItem, setSelectedItem] = useState<IHelpTags | null>(null);
  const [tags, setTags] = useState<IHelpTags[]>([]);
  const [tipoComunic, setTipoComunic] = useState('');
  
  const selectTipo = watch('IdCanal');
  const selectFornedora = watch('IdFornecedora');

  const listKeyValueStatus: IKeyValue[] = [
    {
      key: 'A',
      value: 'Ativo'
    }, {
      key: 'I',
      value: 'Inativo'
    },];

  const [stateSnack, setStateSnack] = useState({
    open: false,
    severity: 'success',
    message: '',
  });



  const selectTitle = watch('ComunicacaoTitulo');
  const selectText = watch('TextoCliente');

  const [textTitle, setTextTitle] = useState<string>(id == 'novo' ? '' : selectTitle);
  const [textMsg, setTextMsg] = useState<string>(id == 'novo' ? '' : selectText);
  const [textoHtml, setTextoHtml] = useState<string>(id == 'novo' ? '' : selectText);

  const [showModal, setShowModal] = useState(false);
  const [showHelpTag, setShowHelpTag] = useState(false);
  const [previewContent, setPreviewContent] = useState('');

  const [showPickerTitle, setShowPickerTitle] = useState<boolean>(false);
  const [showPickerMsg, setShowPickerMsg] = useState<boolean>(false);
  const [focarMsg, setfocarMsg] = useState<boolean>(false);
  const [focarTitle, setfocarTitle] = useState<boolean>(false);
  const textFieldRef = useRef<HTMLInputElement>(null);


  const handleTextoHtmlChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setfocarMsg(true);
    setfocarTitle(false);
    setTextoHtml(event.target.value);

  };

  const handlePreviewButtonClick = () => {
    setShowModal(true);
    setPreviewContent(id === 'novo' ? textoHtml : textMsg);
  };
  const handleHelptags = () => {
    setShowHelpTag(true);
    //setPreviewContent(id === 'novo' ? textoHtml : textMsg);
  };


  const onEmojiClickTitle = (emoji: EmojiClickData) => {
    setfocarMsg(false);
    setfocarTitle(true);
    if (emoji && emoji.emoji) {

      setTextTitle((prevText) => prevText + emoji.emoji);
      setShowPickerTitle(false);
    }
  };

  const onEmojiClickMsg = (emoji: EmojiClickData) => {
    setfocarMsg(true);
    setfocarTitle(false);
    if (emoji && emoji.emoji) {
      setTextMsg((prevText) => prevText + emoji.emoji);
      setShowPickerMsg(false);
    }
  };

  const handleButtonClick = (value: SetStateAction<string>) => {

    setTextMsg((prevText) => prevText + '##' + value + '##');
    setTextoHtml((prevText) => prevText + '##' + value + '##');
    setShowHelpTag(false);
    setfocarMsg(true);

  };

  const handleChangeRadio = (value: string) => {
    setTipoComunic(value.trim());
  };


  useEffect(() => {
    if (textFieldRef.current) {
      // Posiciona o cursor no final do campo após a atualização do valor
      textFieldRef.current.selectionStart = textFieldRef.current.value.length;
      textFieldRef.current.selectionEnd = textFieldRef.current.value.length;
    }
  }, [textMsg]);



  const handleInputChangeTitle = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTextTitle(event.target.value);
    setfocarMsg(false);
    setfocarTitle(true);
  };
  const handleInputChangeMsg = (event: React.ChangeEvent<HTMLInputElement>) => {
    setfocarMsg(true);
    setfocarTitle(false);
    setTextMsg(event.target.value);
  };

  const togglePickerTitle = (): void => {
    setTextTitle(textTitle);
    setShowPickerTitle(val => !val);
  };
  const togglePickerMsg = (): void => {
    setTextMsg(textMsg);
    setShowPickerMsg(val => !val);
  };

  const ConvertEmojiToCode = (texto: string): string => {
    const regex = /[\p{Emoji}]/gu;
    const hasEmoji = texto.match(regex);
    if (hasEmoji) {
      hasEmoji.forEach((emoji) => {

        const emojiCode = emoji.codePointAt(0)?.toString(16);
        if(emojiCode != '23')
          texto = texto.replace(emoji, ' emoji/' + emojiCode! + ' ');
      });
    }
    return texto;
  };

  const ConvertCodeEmoji = (texto: string): string => {
    const validaEmoji = texto.includes('emoji/');
    let textoCompiled = texto;
    if (validaEmoji) {
      const arrayTexto = texto.split(' ');
      textoCompiled = '';
      arrayTexto.forEach((emoji) => {
        const validaEmoji2 = emoji.includes('emoji/');
        if (validaEmoji2) {
          emoji = emoji.replace('emoji/', '');
          emoji = String.fromCodePoint(parseInt(emoji, 16));
        }
        textoCompiled = textoCompiled + emoji + ' ';
      });
    }
    return textoCompiled;
  };

  useEffect(() => {
    setAlert(null);
    if (id !== 'novo') {
      setIsLoading(true);
      ComunicacaoService.getById(String(id), Number(org?.CodigoOrganizacao))
        .then((result) => {
          if (result instanceof Error) {
            setAlert({
              text: result.message,
              type: 'error',
            });
            navigate('/comunicacao/listagem');
          } else {
            setTipoComunic(result.rows[0].ComunicacaoTipo.trim());
            result.rows[0].ComunicacaoTitulo = ConvertCodeEmoji(result.rows[0].ComunicacaoTitulo);
            result.rows[0].TextoCliente = ConvertCodeEmoji(result.rows[0].TextoCliente);
            setTextTitle(result.rows[0].ComunicacaoTitulo);
            setTextMsg(result.rows[0].TextoCliente);
            setComunicacao(result.rows[0]);
            reset(result.rows[0]);
          }
          setIsLoading(false);
        });
    }
    else {
      reset(InicitalCreateComunicacao);
    }

  }, [id, Fornecedora]);
  useEffect(() => {

    setIsLoading(true);

    OrganizationsService.getAll()
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setStateSnack({ open: true, severity: 'error', message: `Ocorreu o seguinte erro: ${result.message}` });
        } else {
          setListKeyValueOrg(listagemOrgToIKeyValue(result.rows));
        }
      });
  }, []);

  useEffect(() => {
    setIsLoadingCanal(true);

    CanaisService.getAll()
      .then((result) => {
        setIsLoadingCanal(false);
        if (result instanceof Error) {
          setStateSnack({ open: true, severity: 'error', message: `Ocorreu o seguinte erro: ${result.message}` });
        } else {
          setListKeyValueCanal(listagemCanalToIKeyValue(result));
        }
      });
  }, []);

  useEffect(() => {
    setisLoadingFornecedora(true);
    FornecedorasService.get()
      .then((result) => {
        setisLoadingFornecedora(false);
        if (result instanceof Error) {
          setStateSnack({ open: true, severity: 'error', message: `Ocorreu o seguinte erro: ${result.message}` });
        } else {
          setListKeyValueFornecedora(result);
        }
      });
  }, []);

  useEffect(() => {
    setIsLoading(true);
    ComunicacaoService.getTags(searchParams.toString())
      .then((result) => {
        setIsLoading(false);

        if (result instanceof Error) {
          setStateSnack({ open: true, severity: 'error', message: `Ocorreu o seguinte erro: ${result.message}` });
        } else {
          setTotalCount(result.count);
          setRows(result.rows);
          setTags(result.rows);

        }
      });
  }, []);


  const handleDelete = () => {
    setTitleConfirmacao(t('components.actions.apagar'));
    setMessageConfirmacao(t('messages.organizationSeletion.exclusion') + id + '?');
    setOpenConfirmacao(true);
    console.log('handleDelete');
  };

  const confirmDelete = () => {
    setAlert(null);
    ComunicacaoService.deleteD(String(id))
      .then(result => {
        if (result instanceof Error) {
          setAlert({
            text: result.message,
            type: 'error',
          });
          setOpenConfirmacao(false);
        } else {
          setAlert({
            text: 'Registro apagado com sucesso!',
            type: 'error',
          });
          navigate('/fornecedora/listagem');
        }
      })
      .catch(reason => {
        setAlert({
          text: reason,
          type: 'error',
        });
        setOpenConfirmacao(false);
      });
  };


  console.log(tipoComunic);
  const onSubmit = async (data: ICreateComunicacao) => {

    setAlert(null);
    setIsSubmitting(true);
    if (data.IdCanal == 3) {
      data.ComunicacaoTitulo = ConvertEmojiToCode(String(data.ComunicacaoTitulo));
      data.TextoCliente = ConvertEmojiToCode(String(data.TextoCliente));
    }

    if (id === 'novo') {
      console.log(tipoComunic.toString() + 'criado');
      ComunicacaoService
        .create(Number(org?.CodigoOrganizacao), data, tipoComunic)
        .then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {
            setAlert({
              text: result.message,
              type: 'error',
            });
          } else {
            if (isSaveAndClose()) {
              navigate('/comunicacao/listagem');
            } setAlert({
              text: t('messages.success.incluido'),
              type: 'success',
            });
          }
        })
        .finally(() => {
          setIsSubmitting(false);
        });

    } else {
      console.log(tipoComunic.toString() + 'criado');
      ComunicacaoService
        .update(Number(org?.CodigoOrganizacao), Number(id), data, tipoComunic)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setAlert({
              text: result.message,
              type: 'error',
            });
          } else {
            if (isSaveAndClose()) {
              navigate('/fornecedora/listagem');
            }
            setAlert({
              text: t('messages.success.alterado'),
              type: 'success',
            });


          }
        })
        .finally(() => {
          setIsSubmitting(false);
        });

    }

  };


  // console.log(selectTipo);
  // console.log(selectFornedora);
  
  return (
    <LayoutBaseDePagina

      titulo={id === 'novo' ? t('pages.comunicacao.newComunicacao') : hasPermitionUpdate ? t('pages.comunicacao.changeComunicacao') : t('pages.comunicacao.viewComunicacao')}

      barraDeFerramentas={!(isLoading || isSubmitting) && (
        <FerramentasDeDetalhe
          idForm='formDetalheDeComunicacao'

          mostrarBotaoNovo={id == 'novo' || hasPermitionCreate}
          mostrarBotaoApagar={false}
          mostrarBotaoSalvar={id == 'novo' || hasPermitionUpdate}




          aoClicarEmSalvar={save}
          aoClicarEmVoltar={() => navigate('/comunicacao/listagem')}
          aoClicarEmApagar={() => handleDelete()}
          aoClicarEmNovo={() => navigate('/comunicacao/detalhe/novo/')}


        />


      )
      }
    >
      <Box ref={formRef} id='formDetalheDeComunicacao' component="form" display="flex" autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined" width='100%'  >

          <Card >
            <CardContent sx={{ padding: 0 }} >
              <div>
                {alert ? (
                  <>
                    <Grid item xs={12} paddingX={2}>
                      <Alert severity={alert.type} onClose={() => setAlert(null)} sx={{ marginTop: '1rem', marginBottom: '0' }}>
                        {alert.text}
                      </Alert>
                    </Grid>
                  </>
                ) : (
                  <Grid item xs={12} component={Typography} paddingX={2}>

                  </Grid>
                )}
                <Grid container  >

                  <Grid item xs={6} paddingX={2}>
                    <TextField
                      error={errors?.Comunicacao?.type ? true : false}
                      fullWidth
                      disabled={isSubmitting || isLoading || (!hasPermitionUpdate && id !== 'novo')}
                      id='Comunicacao'
                      type='text'
                      label={`${t('pages.comunicacao.nome')} *`}
                      {...register('Comunicacao')}
                      sx={{ marginTop: '1rem', marginBottom: '0' }}
                      inputProps={{ maxLength: 50 }}
                    />
                    {errors?.Comunicacao?.type && <InputError type={errors.Comunicacao.type} field='Comunicacao' />}
                  </Grid>


                  <Grid item xs={3} paddingX={2}>
                    <FormControl fullWidth sx={{ marginTop: '1rem', marginBottom: '0' }}>
                      <InputLabel id='label-select-tipo'>{`${t('pages.orgFornecedora.Canal')} *`}</InputLabel>
                      <Select
                        disabled={isSubmitting || isLoading || id != 'novo'}
                        error={errors?.Canal?.type ? true : false}
                        labelId='label-select-tipo'
                        id='IdCanal'

                        input={<OutlinedInput label={`${t('pages.orgFornecedora.Canal')} *`} />}
                        {...register('IdCanal')}
                        value={selectTipo || ''}

                      >
                        <MenuItem value=''>
                          <ListItemText primary='' />
                        </MenuItem>
                        {listKeyValueCanal.map((item) => (
                          <MenuItem key={item.key} value={item.key} >
                            <ListItemText primary={item.value} sx={{ margin: '0' }} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {errors?.Canal?.type && <InputError type={errors.Canal.type} field='Canal' />}

                  </Grid>

                  <Grid item xs={3} paddingX={2}>
                    <FormControl fullWidth sx={{ marginTop: '1rem', marginBottom: '0' }}>
                      <InputLabel id='label-select-tipo'>{`${t('pages.orgFornecedora.Fornecedora')} *`}</InputLabel>
                      <Select
                        required={true}
                        disabled={isSubmitting || isLoading || id != 'novo'}
                        error={errors?.Fornecedora?.type ? true : false}
                        labelId='label-select-tipo'
                        id='IdFornecedora'

                        input={<OutlinedInput label={`${t('pages.orgFornecedora.Fornecedora')} *`} />}
                        {...register('IdFornecedora')}
                        value={selectFornedora || ''}

                      >
                        <MenuItem value=''>
                          <ListItemText primary='' />
                        </MenuItem>
                        {listKeyValueFornecedora?.filter((item) => item.IdCanal === Number(selectTipo)).map((item) => (
                          <MenuItem key={item.IdFornecedora} value={item.IdFornecedora} >
                            <ListItemText style={{ overflow: 'hidden' }} primary={item.NomeFornecedora} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {errors?.Fornecedora?.type && <InputError type={errors.Fornecedora.type} field='Fornecedora' />}

                  </Grid>
                  <Grid item xs={12} paddingX={2}>
                    <TextField
                      error={errors?.ComunicacaoDescricao?.type ? true : false}
                      fullWidth
                      disabled={isSubmitting || isLoading || (!hasPermitionUpdate && id !== 'novo')}
                      id='ComunicacaoDescricao'
                      type='text'
                      label={`${t('pages.comunicacao.descricao')} *`}
                      {...register('ComunicacaoDescricao')}
                      sx={{ marginTop: '1rem', marginBottom: '0' }}
                      inputProps={{ maxLength: 50 }}
                    />
                    {errors?.ComunicacaoDescricao?.type && <InputError type={errors.ComunicacaoDescricao.type} field='ComunicacaoDescricao' />}
                  </Grid>

                  {(selectTipo === 2 || selectTipo === '2') && (selectFornedora == 3 || selectFornedora == '3') ||
                    (selectTipo === 6 || selectTipo === '6') && (selectFornedora == 9 || selectFornedora == '9')?
                    <Grid item xs={6} paddingX={2}>
                      <TextField
                        error={errors?.IdCampanhaExt?.type ? true : false}
                        fullWidth
                        disabled={isSubmitting || isLoading || (!hasPermitionUpdate && id !== 'novo')}
                        id='IdCampanhaExt'
                        type='text'
                        label={selectTipo === '2'? t('pages.comunicacao.idCampanhaExt') : t('pages.comunicacao.idJornada')}
                        {...register('IdCampanhaExt')}
                        sx={{ marginTop: '1rem', marginBottom: '0' }}
                        inputProps={{ maxLength: 30 }}
                      />
                      {errors?.IdCampanhaExt?.type && <InputError type={errors.IdCampanhaExt.type} field='IdCampanhaExt' />}
                    </Grid>
                    :''
                  }

                  {(selectTipo === 3 || selectTipo === '3')?
                    <>
                      <Grid item xs={12} paddingX={2}>
                        <TextField
                          autoFocus={focarTitle}
                          error={errors?.ComunicacaoTitulo?.type ? true : false}
                          fullWidth
                          disabled={isSubmitting || isLoading || (!hasPermitionUpdate && id !== 'novo')}
                          id='ComunicacaoTitulo'
                          type='text'
                          value={textTitle}
                          label={`${t('pages.comunicacao.titulomsg')} *`}
                          {...register('ComunicacaoTitulo')}
                          sx={{ marginTop: '1rem', marginBottom: '0' }}
                          onInput={handleInputChangeTitle}
                          InputProps={{
                            startAdornment:
                              <img
                                style={{cursor: 'pointer'}}
                                className="emoji-icon"
                                src="https://icons.getbootstrap.com/assets/icons/emoji-smile.svg"
                                onClick={togglePickerTitle}
                              />
                          }}
                        />
                        {errors?.ComunicacaoTitulo?.type && <InputError type={errors.ComunicacaoTitulo.type} field='ComunicacaoTitulo' />}
                        {showPickerTitle && (

                          <EmojiPicker
                            onEmojiClick={onEmojiClickTitle}
                          />
                        )}

                      </Grid>

                      <Grid item xs={12} paddingX={2}>
                        <TextField
                          error={errors?.TextoCliente?.type ? true : false}
                          autoFocus={focarMsg}
                          fullWidth
                          disabled={isSubmitting || isLoading || (!hasPermitionUpdate && id !== 'novo')}
                          multiline={true}
                          rows={2}
                          id='TextoCliente'
                          type='text'
                          inputRef={textFieldRef}
                          value={textMsg}
                          label={`${t('pages.comunicacao.mensagemCliente')} *`}
                          {...register('TextoCliente')}
                          sx={{ marginTop: '1rem', marginBottom: '0' }}
                          onInput={handleInputChangeMsg}
                          InputProps={{
                            startAdornment:
                              <img
                                style={{cursor: 'pointer'}}
                                className="emoji-icon"
                                src="https://icons.getbootstrap.com/assets/icons/emoji-smile.svg"
                                onClick={togglePickerMsg}
                              />
                          }}
                        />
                        <div style={{ marginTop: '8px' }}>
                          {showPickerMsg && (
                            
                            <EmojiPicker
                              onEmojiClick={onEmojiClickMsg}
                            />
                          )}

                          <Button color='info' variant="contained" size='small'
                            onClick={handleHelptags} startIcon={<Icon>grid_3x3</Icon>}>
                            Help Tags
                          </Button>
                        </div>
                        {errors?.TextoCliente?.type && <InputError type={errors.TextoCliente.type} field='TextoCliente' />}
                      
                      </Grid>

                      <Grid item xs={6} paddingX={2}>
                        <TextField
                          error={errors?.UrlImagem?.type ? true : false}
                          fullWidth
                          disabled={isSubmitting || isLoading || (!hasPermitionUpdate && id !== 'novo')}
                          id='UrlImagem'
                          type='text'
                          label={`${t('pages.comunicacao.imagem')} `}
                          {...register('UrlImagem')}
                          sx={{ marginTop: '1rem', marginBottom: '0' }}
                          inputProps={{ maxLength: 15 }}
                        />
                        {errors?.UrlImagem?.type && <InputError type={errors.UrlImagem.type} field='UrlImagem' />}
                      </Grid>

                      <Grid item xs={6} paddingX={2}>
                        <TextField
                          error={errors?.AcaoAndrd?.type ? true : false}
                          fullWidth
                          disabled={isSubmitting || isLoading || (!hasPermitionUpdate && id !== 'novo')}
                          id='AcaoAndrd'
                          type='text'
                          label={`${t('pages.comunicacao.urlandroid')}`}
                          {...register('urlandroid')}
                          sx={{ marginTop: '1rem', marginBottom: '0' }}
                          inputProps={{ maxLength: 15 }}
                        />
                        {errors?.AcaoAndrd?.type && <InputError type={errors.AcaoAndrd.type} field='AcaoAndrd' />}
                      </Grid>
                      <Grid item xs={6} paddingX={2}>
                        <TextField
                          error={errors?.AcaoIos?.type ? true : false}
                          fullWidth
                          disabled={isSubmitting || isLoading || (!hasPermitionUpdate && id !== 'novo')}
                          id='AcaoIos'
                          type='text'
                          label={`${t('pages.comunicacao.urlios')} `}
                          {...register('AcaoIos')}
                          sx={{ marginTop: '1rem', marginBottom: '0' }}
                          inputProps={{ maxLength: 15 }}
                        />
                        {errors?.AcaoIos?.type && <InputError type={errors.AcaoIos.type} field='AcaoIos' />}
                      </Grid>


                    </>
                    : ''
                  }

                  {(selectTipo === 1 || selectTipo === '1') ||
                   (selectTipo === 6 || selectTipo === '6') ?
                    <>
                      <Grid item xs={12} paddingX={2}>

                        <TextField
                          error={errors?.TextoCliente?.type ? true : false}
                          fullWidth
                          autoFocus={focarMsg}
                          disabled={isSubmitting || isLoading || (!hasPermitionUpdate && id !== 'novo')}
                          multiline={true}
                          rows={3}
                          id='TextoCliente'
                          type='text'
                          inputRef={textFieldRef}
                          value={textMsg}
                          label={`${t('pages.comunicacao.mensagemCliente')} *`}
                          {...register('TextoCliente')}
                          sx={{ marginTop: '1rem', marginBottom: '0' }}
                          onInput={handleInputChangeMsg}
                          inputProps={{ maxLength: 160 }}
                        />
                        <div style={{ marginTop: '8px' }}>
                          <Button color='info' variant="contained" size='small'
                            onClick={handleHelptags} startIcon={<Icon>grid_3x3</Icon>}>
                            Help Tags
                          </Button>
                        </div>
                        {errors?.TextoCliente?.type && <InputError type={errors.TextoCliente.type} field='TextoCliente' />}
                      </Grid>

                    </>
                    :
                    ''
                  }

                  {(selectTipo === 2 || selectTipo === '2') && (selectFornedora == 3 || selectFornedora == '3') ? 
                    <>
                      <RadioGroup
                        aria-labelledby="ComunicacaoTipo"
                        id="ComunicacaoTipo"
                        name="ComunicacaoTipo"
                        value={tipoComunic} 
                        onChange={(event) => handleChangeRadio(event.target.value)}
                      >
                        <FormControlLabel key='EXT' value="EXT" control={<Radio />} label={t('pages.comunicacao.broker')} />
                        <FormControlLabel key='INT' value="INT"  control={<Radio />} label={t('pages.comunicacao.padrao')} />
                      </RadioGroup>
                      { tipoComunic === 'EXT' ?
                        <Grid item xs={12} paddingX={2}>
                          <TextField
                            error={errors?.TextoCliente?.type ? true : false}
                            autoFocus={focarMsg}
                            fullWidth
                            disabled={isSubmitting || isLoading || (!hasPermitionUpdate && id !== 'novo')}
                            multiline={true}
                            rows={2}
                            id='TextoCliente'
                            type='text'
                            inputRef={textFieldRef}
                            value={textMsg}
                            label={`${t('pages.comunicacao.mensagemCliente')} *`}
                            {...register('TextoCliente')}
                            sx={{ marginTop: '1rem', marginBottom: '0' }}
                            onInput={handleInputChangeMsg}
                          />
                          <div style={{ marginTop: '8px' }}>
                            <Button color='info' variant="contained" size='small'
                              onClick={handleHelptags} startIcon={<Icon>grid_3x3</Icon>}>
                              Help Tags
                            </Button>
                          </div>
                          {errors?.TextoCliente?.type && <InputError type={errors.TextoCliente.type} field='TextoCliente' />}
                      
                        </Grid>
                        :''
                      }
                      {   
                        tipoComunic === 'INT' ?
                          <>
                            <Grid item xs={6} paddingX={2}>
                              <TextField
                                error={errors?.IdCampanhaCampo?.type ? true : false}
                                fullWidth
                                disabled={isSubmitting || isLoading || (!hasPermitionUpdate && id !== 'novo')}
                                id='IdCampanhaCampo'
                                type='text'
                                label={t('pages.comunicacao.idCampanhaCampo')}
                                {...register('IdCampanhaCampo')}
                                sx={{ marginTop: '1rem', marginBottom: '0' }}
                                inputProps={{ maxLength: 30 }}
                              />
                              {errors?.IdCampanhaCampo?.type && <InputError type={errors.IdCampanhaCampo.type} field='IdCampanhaCampo' />}
                            </Grid>
                            <Grid item xs={12} paddingX={2}>
                              <TextField
                                autoFocus
                                error={errors?.TextoCliente?.type ? true : false}
                                fullWidth
                                disabled={isSubmitting || isLoading || (!hasPermitionUpdate && id !== 'novo')}
                                multiline={true}
                                rows={8}
                                id='TextoCliente'
                                type='text'
                                value={id === 'novo' ? textoHtml : textMsg}
                                label={`${t('pages.comunicacao.mensagemHTML')} *`}
                                {...register('TextoCliente')}
                                sx={{ marginTop: '1rem', marginBottom: '0' }}
                                onChange={id == 'novo' ? handleTextoHtmlChange : handleInputChangeMsg}

                              />
                              <div style={{ marginTop: '8px' }}>
                                <Button color='info' variant="contained" size='small'
                                  onClick={handleHelptags} startIcon={<Icon>grid_3x3</Icon>}>
                                  Help Tags
                                </Button>
                                <Button color='inherit' variant="contained" size='small'
                                  onClick={handlePreviewButtonClick} startIcon={<Icon>visibility</Icon>}>
                                  Preview
                                </Button>
                              </div>
                              {errors?.TextoCliente?.type && <InputError type={errors.TextoCliente.type} field='TextoCliente  ' />}
                            </Grid>
                          </>
                          :''
                      }
                    </>
                    :
                    ''
                  }


                  {(selectTipo === 2 || selectTipo === '2') && (selectFornedora != 3 || selectFornedora != '3') ?
                    <>
                      <Grid item xs={6} paddingX={2}>
                        <TextField
                          error={errors?.AssuntoEmail?.type ? true : false}
                          fullWidth
                          disabled={isSubmitting || isLoading || (!hasPermitionUpdate && id !== 'novo')}
                          id='AssuntoEmail'
                          type='text'
                          label={`${t('pages.comunicacao.assunto')} *`}
                          {...register('AssuntoEmail')}
                          sx={{ marginTop: '1rem', marginBottom: '0' }}
                          inputProps={{ maxLength: 30 }}
                        />
                        {errors?.AssuntoEmail?.type && <InputError type={errors.AssuntoEmail.type} field='AssuntoEmail' />}
                      </Grid>
                      <Grid item xs={4} paddingX={2}>
                        <TextField
                          error={errors?.RemetenteEmail?.type ? true : false}
                          fullWidth
                          disabled={false}
                          id='RemetenteEmail'
                          type='text'
                          value={'crmpefisa@crmpefisa.pernambucanas.com.br'}
                          label={`${t('pages.comunicacao.remetente')} *`}
                          {...register('RemetenteEmail')}
                          sx={{ marginTop: '1rem', marginBottom: '0' }}
                          inputProps={{ maxLength: 30 }}
                        />
                        {errors?.RemetenteEmail?.type && <InputError type={errors.RemetenteEmail.type} field='RemetenteEmail' />}
                      </Grid>

                      <Grid item xs={4} paddingX={2}>
                        <TextField
                          error={errors?.NomeRemetenteEmail?.type ? true : false}
                          fullWidth
                          disabled={false}
                          id='NomeRemetenteEmail'
                          type='text'
                          value={'Pernambucanas'}
                          label={`${t('pages.comunicacao.nomeRemetente')} *`}
                          {...register('NomeRemetenteEmail')}
                          sx={{ marginTop: '1rem', marginBottom: '0' }}
                          inputProps={{ maxLength: 30 }}
                        />
                        {errors?.NomeRemetenteEmail?.type && <InputError type={errors.NomeRemetenteEmail.type} field='NomeRemetenteEmail' />}
                      </Grid>

                      <Grid item xs={4} paddingX={2}>
                        <TextField
                          error={errors?.RespostaEmail?.type ? true : false}
                          fullWidth
                          disabled={false}
                          id='RespostaEmail'
                          type='text'
                          value={'noreply@crmpefisa.pernambucanas.com.br'}
                          label={`${t('pages.comunicacao.resposta')} *`}
                          {...register('RespostaEmail')}
                          sx={{ marginTop: '1rem', marginBottom: '0' }}
                          inputProps={{ maxLength: 15 }}
                        />
                        {errors?.RespostaEmail?.type && <InputError type={errors.RespostaEmail.type} field='RespostaEmail' />}

                      </Grid>

                      <Grid item xs={12} paddingX={2}>

                        <TextField
                          autoFocus
                          error={errors?.TextoCliente?.type ? true : false}
                          fullWidth
                          disabled={isSubmitting || isLoading || (!hasPermitionUpdate && id !== 'novo')}
                          multiline={true}
                          rows={8}
                          id='TextoCliente'
                          type='text'
                          value={id === 'novo' ? textoHtml : textMsg}
                          label={`${t('pages.comunicacao.mensagemHTML')} *`}
                          {...register('TextoCliente')}
                          sx={{ marginTop: '1rem', marginBottom: '0' }}
                          onChange={id == 'novo' ? handleTextoHtmlChange : handleInputChangeMsg}

                        />
                        <div style={{ marginTop: '8px' }}>
                          <Button color='info' variant="contained" size='small'
                            onClick={handleHelptags} startIcon={<Icon>grid_3x3</Icon>}>
                            Help Tags
                          </Button>
                          <Button color='inherit' variant="contained" size='small'
                            onClick={handlePreviewButtonClick} startIcon={<Icon>visibility</Icon>}>
                            Preview
                          </Button>
                        </div>
                        {errors?.TextoCliente?.type && <InputError type={errors.TextoCliente.type} field='TextoCliente  ' />}
                      </Grid>

                    </>
                    :
                    ''
                  }
                </Grid>
              </div>
            </CardContent>

          </Card>
        </Box>
        {setShowHelpTag && (
          <Box >
            <Modal style={{
              backgroundColor: 'white',
              width: '60%',
              height: '50%',
              position: 'absolute',
              top: '100px',
              left: '300px',
              right: '100px',
              bottom: '100px',
              overflow: 'auto'
            }} onClose={() => setShowHelpTag(false)} open={showHelpTag} >
              <><TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ paddingLeft: '100px' }} > <strong>{t('components.helpTag.tag')}</strong></TableCell>
                      <TableCell sx={{ paddingRight: '50px' }}><strong>{t('components.helpTag.descricao')}</strong></TableCell>
                      <TableCell sx={{ paddingRight: '50px' }}><strong>{t('components.helpTag.tamanho')}</strong></TableCell>
                    </TableRow> 
                  </TableHead>                         
                </Table>
              </TableContainer>
              <TableContainer component={Paper}>
                <Autocomplete
                  fullWidth
                  options={tags}
                  open={true}
                  clearOnBlur
                  getOptionLabel={(option) => (option as IHelpTags).TagDadosVariaveis}
                  value={selectedItem}
                  onChange={(_, newValue) => {
                    setSelectedItem(newValue as IHelpTags);
                  }}
                  noOptionsText={t('messages.tagSeletion.notFoundTag')}
                  renderInput={(params) => <TextField {...params} placeholder={t('messages.tagSeletion.selectTag')} />}
                  renderOption={(props, option) => (
                    <Table key={option.ROW_NUM}>
                      <TableHead>
                        <TableRow>
                          <TableCell>
                            <Button onClick={() => handleButtonClick(option.TagDadosVariaveis)} color='info' variant="text" size='medium' style={{ minWidth: '200px' }}
                            > #{option.TagDadosVariaveis}</Button></TableCell>
                          <TableCell>
                            <Button color='success' variant="text" size='medium' style={{ minWidth: '200px' }}
                            >{option.DescDadosVariaveis}</Button></TableCell>
                          <TableCell>
                            <Button color='success' variant="text" size='medium' style={{ minWidth: '200px' }}
                            >{option.TamMaxDadosVariaveis} caracteres</Button></TableCell>
                        </TableRow>
                      </TableHead>
                    </Table>
                  )}
                />
              </TableContainer>
              </>
            </Modal>
          </Box>
        )}
        {showModal && (
          <Box >
            <Modal style={{
              backgroundColor: 'white',
              width: '60%',
              height: '60%',
              position: 'absolute',
              top: '100px',
              left: '300px',
              right: '100px',
              bottom: '100px',
              overflow: 'auto'
            }} onClose={() => setShowModal(true)} open={showModal} >
              <div><CloseIcon
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '10px',
                  cursor: 'pointer'
                }}
                onClick={() => setShowModal(false)}
              />
              <div style={{
                backgroundColor: 'white',
                width: '100%',
                height: '100%',
              }} dangerouslySetInnerHTML={{ __html: previewContent }} />
              </div>
            </Modal>
          </Box>
        )}
        <ConfirmacaoModal
          open={openConfirmacao}
          title={titleConfirmacao}
          message={messageConfirmacao}
          onClose={() => setOpenConfirmacao(false)}
          onConfirm={() => confirmDelete()}
        />
      </Box>
      {
        (isLoading || isSubmitting) && (<Box sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <CircularProgress />
        </Box>)
      }
    </LayoutBaseDePagina >
  );
};


